export default {
	tenantId: "coverHealth",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "coverhealth--prod",
	},
}
